
// Save new profile information to localStorage
export const saveNewProfileInfo = (data) => {
  const { email, phoneNumber, displayName } = data;
  const profile = { email, phoneNumber, displayName };
  localStorage.setItem("profile", JSON.stringify(profile));
};

// Retrieve new profile information from localStorage
export const getNewProfileInfo = () =>
  JSON.parse(localStorage.getItem("profile"));

